<template>
  <section id="section-3" class="content-current">
    <div class="row">
      <div class="col-md-11"></div>
      <div class="col-md-1">
        <router-link to="/profile/dashboard">
          <div title="بازگشت به داشبورد" class="close"></div>
        </router-link>
      </div>
    </div>
    <table class="table tablesorter  add_bottom_30">
      <thead class="thead-light">
        <tr>
          <th>نام</th>
          <th>نام خانوادگی</th>
          <th>جنسیت</th>
          <th>خط هواپیمائی</th>
          <th>شماره پرواز</th>
          <th>شماره بلیط</th>
          <th>تاریخ ورود</th>
          <th>مبدا</th>
          <th>مقصد</th>
          <th>شماره رزرو</th>
          <th>مبلغ پرداخت شده</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, key) in flightList">
          <td>{{ item.firstName }}</td>
          <td>{{ item.familyName }}</td>
          <td v-if="item.gender === false">مرد</td>
          <td v-if="item.gender === true">زن</td>
          <td>{{ item.airLine }}</td>
          <td>{{ item.flightNumber }}</td>
          <td>{{ item.ticketNumber }}</td>
          <td>{{ item.arrivalDatetime | persianDate("jYYYY/jMM/jDD") }}</td>
          <td>{{ item.originAirport }}</td>
          <td>{{ item.destinationAirport }}</td>
          <td>{{ item.pnr }}</td>
          <td>{{ parseInt(item.totalFare) | numFormat }}</td>
        </tr>
      </tbody>
    </table>
    <!-- <nav aria-label="Page navigation">
      <ul class="pagination">
        <li class="page-item" v-if="currentPage == 1" style="color: #999 !important;">
          <a class="page-link">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li class="page-item" v-if="currentPage > 1">
          <a
            class="page-link"
            href="#"
            aria-label="Previous"
            @click.prevent="setPage(currentPage - 1)"
          >
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li
          v-for="pageNumber in totalPages"
          :class="{ active: pageNumber == currentPage }"
          class="page-item"
        >
          <a class="page-link" href="#" @click.prevent="setPage(pageNumber)">{{
            pageNumber
          }}</a>
        </li>

        <li class="page-item" v-if="currentPage != totalPages">
          <a
            class="page-link"
            href="#"
            aria-label="Next"
            @click.prevent="setPage(currentPage + 1)"
          >
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>

        <li class="page-item" v-if="currentPage == totalPages" style="color: #999 !important;">
          <a class="page-link">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>
    </nav> -->
    <paginate 
      v-model="currentPage"
      :page-count="resultCount"
      :page-range="3"
      :margin-pages="2"
      :click-handler="getFlightList"
      :active-class="'paginate-active'"
      :prev-text="'<<'"
      :next-text="'>>'"
      :container-class="'pagination'"
      :page-class="'page-item'"
    >
    </paginate>
  </section>
</template>

<script>
import Store from "../../../views/profile/store/index";

export default {
  name: "flightReserve",
  store: Store,
  data() {
    return {
      flightList: [],
      sourceId: 0,
      currentPage: 1,
      maxRow: 10,
      resultCount: 0,
    };
  },
  created() {
    this.getSourceId();
    this.getFlightList();
  },
  computed: {
    totalPages: function () {
      if (this.sourceId == "") {
        this.$router.push("/profile/dashboard");
      } else {
        this.getFlightList();
        return Math.ceil(this.resultCount / this.maxRow);
      }
    },
  },
  methods: {
    getSourceId() {
      this.sourceId = localStorage.getItem('SourceIdInReport');
    },
    getFlightList() {
      this.$store
        .dispatch("getAllFlightReservedBySourceId", {
          sourceId: this.sourceId,
          currentPage: this.currentPage,
          maxRow: this.maxRow,
        })
        .then((res) => {
          if (res != undefined) {
            this.flightList = res.lstFlightReserved;
            this.resultCount = res.pageCount;
            this.currentPage = res.currentPage;
          
          }
        });
    },

    setPage: function (pageNumber) {
      this.currentPage = pageNumber;
    },
  },
  filters: {
    // paginate() {
    //   this.getFlightList();
    //   if (this.currentPage >= this.totalPages) {
    //     this.currentPage = Math.max(0, this.totalPages - 1);
    //   }
    //   var index = this.currentPage * this.maxRow;
    //   return this.items.slice(index, index + this.maxRow);
    // },
  },
};
</script>

<style scoped>
/* Bootstrap.css */
@media screen and (max-width: 767px) {
  .table-responsive {
    width: 100%;
    margin-bottom: 15px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: 1px solid #ddd;
  }
}
.page-link {
  position: relative !important;
  display: block !important;
  padding: 0.5rem 0.75rem !important;
  margin-left: -1px !important;
  line-height: 1.25 !important;
  color: #2a69b1 !important;
  background-color: #fff !important;
  border: 1px solid #dee2e6 !important;
}
.page-link:hover {
  z-index: 2;
  color: #0056b3 !important;
  text-decoration: none !important;
  background-color: #e9ecef !important;
  border-color: #dee2e6 !important;
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff !important;
  background-color: #2a69b1 !important;
  border-color: #2a69b1 !important;
}
.pagination {
  display: flex !important;
  padding-left: 10 !important;
  list-style: none !important;
  border-radius: 0.25rem !important;
  border-color: green !important;
}

.page-item {
  font-weight: bold !important;
  color: rgb(43, 16, 143)!important;
  background-color: white;
  padding: 2px 20px 2px 5px;
}
ul.className {
  list-style-type: none;
  padding: 0;
  max-height: 30px !important;
}


li.paginate-page-item {
  display: inline-block !important;
  margin: 0 10px !important;
  background: rgb(24, 115, 138) !important;
}

.paginate-active {
  font-weight: bold !important;
  color: rgb(224, 45, 45) !important;
  /* background-color: rgb(211, 211, 211); */
  padding: 2px 25px 2px 5px;
}
</style>